import React from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import MDBox from "../../../materialDashboard/components/MDBox";
import {
    useCreateIncidentAttachment,
    useDeleteIncidentAttachment,
    useIncidentQuery,
    useUpdateIncident,
    useUpdateIncidentAttachment
} from "../query";
import IncidentForm from "../IncidentForm";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import LoadingOverlay from "../../../components/LoadingOverlay";


const IncidentEdit = () => {
    const {t} = useTranslation(['incidents']);
    const navigate = useNavigate();
    const {incidentId} = useParams();
    const incidentQuery = useIncidentQuery(incidentId);
    const updateIncident = useUpdateIncident(incidentId, {disableNotification: true});
    const updateIncidentAttachment = useUpdateIncidentAttachment({disableNotification: true});
    const createIncidentAttachment = useCreateIncidentAttachment({disableNotification: true});
    const deleteIncidentAttachment = useDeleteIncidentAttachment({disableNotification: true});
    const {showSuccessNotification, showErrorNotification}  = useFeedbackTools();

    const handleSubmit = async (data) => {
        const {attachments, ...rest} = data;
        await updateIncident.mutateAsync(rest);
        showSuccessNotification(t('query.updateSuccess'));

        const existingAttachments = incidentQuery.data?.attachments ?? [];
        const newAttachments = attachments ?? [];

        try {
            // Delete attachments that are not in the new list
            await Promise.all(existingAttachments.filter(
                (attachment) => !newAttachments.find((a) => a.id === attachment.id)
            )?.map((attachment) => deleteIncidentAttachment.mutateAsync({id: incidentId, attachmentId: attachment.id})));

            // Create or update attachments
            await Promise.all(newAttachments.map((attachment) => {
                if (attachment.id) {
                    return updateIncidentAttachment.mutateAsync({id: incidentId, attachmentId: attachment.id, data: attachment});
                } else {
                    return createIncidentAttachment.mutateAsync({id: incidentId, data: attachment});
                }
            }));
        }
        catch (e) {
            console.error(e);
            showErrorNotification(t('query.createAttachmentError'));
        }
        await navigate('/incidents');
    }

    if (incidentQuery.isLoading) {
        return <LoadingOverlay />
    }

    return <MDBox sx={{mx: 2}}>
        <IncidentForm title={t('incidentEdit.title')}
                      incident={incidentQuery.data}
                      onSubmit={handleSubmit}/>
    </MDBox>
}

export default IncidentEdit;